exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-view[data-v-05c58bc8]{width:140px;height:78px;background:#eee;border-radius:4px;cursor:pointer}.upload-view.shu[data-v-05c58bc8]{height:186px}.upload-view i[data-v-05c58bc8]{font-size:20px;font-weight:600}\n", ""]);

// exports
